const isProd = import.meta.env.VITE_APP_ENVIRONMENT === 'prod'

export const PROVIDER_FIAT = Object.freeze({
  AV: 'AV',
  BC: 'BC',
  CR: 'CR',
  ...(isProd ? {} : { FK: 'FK' })
})

export const AVAILABLE_FIAT_CURRENCIES = Object.freeze({
  USD: 'USD',
  EUR: 'EUR',
  GBP: 'GBP',
  JPY: 'JPY',
  CAD: 'CAD',
  CHF: 'CHF',
  AUD: 'AUD',
  AED: 'AED',
  CNY: 'CNY',
  SEK: 'SEK'
})

export const PROVIDER_CRYPTO = Object.freeze({
  BB: 'BB',
  ...(isProd ? {} : { FK: 'FK' })
})

export const AVAILABLE_CRYPTO_CURRENCIES = Object.freeze({
  USDT: 'USDT',
  USDC: 'USDC'
})

export const BC_CODES = Object.freeze({
  USD: 'USDBRL',
  SEK: 'USDSEK',
  AED: 'USDAED',
  AUD: 'AUDUSD',
  EUR: 'EURUSD',
  GBP: 'GBPUSD',
  JPY: 'JPYUSD',
  CHF: 'CHFUSD',
  CAD: 'CADUSD',
  CNY: 'CNYUSD'
})
